export default "__VITE_ASSET__BGZkWgiO__"